<template>
    <div id="administrator-dashboard">
        <b-overlay :show="showLoading" spinner-variant="primary">

            <b-card no-body>

                <!-- <b-col md="6">
                    <b-form-group>
                        <h5>Disabled Range</h5>
                        <flat-pickr v-model="rangePicker" class="form-control"
                            :config="{ dateFormat: 'Y-m-d', disable: [{ from: '2020-08-20', to: '2020-08-25' }] }" />
                    </b-form-group>
                </b-col> -->
                <b-card-title class="mt-2">

                    <b-row class="justify-content-md-center">

                        <b-col cols="12" md="auto">
                            <div class="d-flex justify-content-center align-items-center">
                                <feather-icon icon="CalendarIcon" size="30" />
                                <flat-pickr v-model="rangePicker" :config="{ mode: 'range' }"
                                    class="form-control flat-picker bg-transparent border-0 shadow-none"
                                    style="width: 150%;font-size: 20px;" placeholder="YYYY-MM-DD" />
                            </div>
                        </b-col>
                    </b-row>

                </b-card-title>

                <b-card-body>
                    <section id="dashboard-admin" :key="showDataKeys">
                        <b-row class="match-height">
                            <b-col lg="6" sm="12">
                                <b-card no-body class="card-revenue-budget">
                                    <b-card-header>
                                        <b-col lg="12" sm="12">
                                            <h3>Classement des Clients : Les 10 Meilleurs en Termes de Nombre de Commandes
                                            </h3>
                                        </b-col>
                                    </b-card-header>
                                    <vue-apex-charts height="400" :options="pieChartNumbers"
                                        :series="pieChartNumbers.series"></vue-apex-charts>
                                </b-card>
                            </b-col>
                            <b-col lg="6" sm="12">
                                <b-card no-body class="card-revenue-budget">
                                    <b-card-header>
                                        <b-col lg="12" sm="12">
                                            <h3>Classement des Clients : Les 10 Meilleurs en Termes de Chiffre d'Affaires
                                            </h3>
                                        </b-col>
                                    </b-card-header>
                                    <vue-apex-charts height="400" :options="pieChartAmount"
                                        :series="pieChartAmount.series"></vue-apex-charts>
                                </b-card>
                            </b-col>
                            <b-col lg="12" sm="12">
                                <b-card no-body class="card-revenue-budget">
                                    <b-card-header>
                                        <b-row class="w-100 align-items-center no-gutters">
                                            <b-col lg="8" sm="12">
                                                <h3>{{ culumnChartNumbersTitle }}</h3>
                                            </b-col>
                                            <b-col lg="4" sm="12">
                                                <b-form-select v-model="comparisonModeNumbers"
                                                    :options="comparisonOptions" />
                                            </b-col>
                                        </b-row>
                                    </b-card-header>
                                    <b-alert :show="comparisonModeNumbers === 'month' && rangeDays >= 50"
                                        variant="warning" class="mx-2 p-1">
                                        Période de plus de 50 jours : les données sont regroupées par mois et chaque mois
                                        est comparé au mois qui le précède (ex. août 2026 vs juillet 2026). Les deux
                                        séries se chevauchent donc en grande partie sur la période sélectionnée — pour ce
                                        type de période, la comparaison avec l'année précédente (N-1) est généralement
                                        plus pertinente.
                                    </b-alert>
                                    <b-alert :show="comparisonModeNumbers === 'month' && rangeDays < 50" variant="info"
                                        class="mx-2 p-1">
                                        Chaque jour est comparé au même jour du mois précédent (ex. 02/08/2026 vs
                                        02/07/2026). Les jours sans équivalent dans le mois précédent (ex. le 31/07 n'a
                                        pas d'équivalent en juin) sont affichés sans valeur de comparaison.
                                    </b-alert>
                                    <vue-apex-charts type="line" height="400" :options="columnChartNumbers.chartOptions"
                                        :series="columnChartNumbers.series"></vue-apex-charts>
                                </b-card>
                            </b-col>
                            <b-col lg="12" sm="12">
                                <b-card no-body class="card-revenue-budget">
                                    <b-card-header>
                                        <b-row class="w-100 align-items-center no-gutters">
                                            <b-col lg="8" sm="12">
                                                <h3>{{ columnChartAmountTitle }}</h3>
                                            </b-col>
                                            <b-col lg="4" sm="12">
                                                <b-form-select v-model="comparisonModeAmount"
                                                    :options="comparisonOptions" />
                                            </b-col>
                                        </b-row>
                                    </b-card-header>
                                    <b-alert :show="comparisonModeAmount === 'month' && rangeDays >= 50"
                                        variant="warning" class="mx-2 p-1">
                                        Période de plus de 50 jours : les données sont regroupées par mois et chaque mois
                                        est comparé au mois qui le précède (ex. août 2026 vs juillet 2026). Les deux
                                        séries se chevauchent donc en grande partie sur la période sélectionnée — pour ce
                                        type de période, la comparaison avec l'année précédente (N-1) est généralement
                                        plus pertinente.
                                    </b-alert>
                                    <b-alert :show="comparisonModeAmount === 'month' && rangeDays < 50" variant="info"
                                        class="mx-2 p-1">
                                        Chaque jour est comparé au même jour du mois précédent (ex. 02/08/2026 vs
                                        02/07/2026). Les jours sans équivalent dans le mois précédent (ex. le 31/07 n'a
                                        pas d'équivalent en juin) sont affichés sans valeur de comparaison.
                                    </b-alert>
                                    <vue-apex-charts type="bar" height="400" :options="columnChartAmount.chartOptions"
                                        :series="columnChartAmount.series"></vue-apex-charts>
                                </b-card>
                            </b-col>
                            <!-- <b-col lg="12" sm="12">
                                <b-card no-body class="card-revenue-budget" >
                                    <b-card-header>
                                        <b-col lg="12" sm="12">
                                            <h3>Variation Quotidienne des Ventes Par Chiffre D'affaires</h3>
                                        </b-col>
                                    </b-card-header>
                                    <vue-apex-charts  type="area" height="400"
                                        :options="columnChartAmount.chartOptions"
                                        :series="columnChartAmount.series"></vue-apex-charts>
                                </b-card>
                            </b-col> -->
                        </b-row>
                    </section>
                </b-card-body>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import {
    kFormatter
} from '@core/utils/filter'
import {
    $themeColors
} from "@themeConfig";
import VueApexCharts from "vue-apexcharts";
export default {
    components: {
        VueApexCharts,
        flatPickr
    },
    data() {
        const vm = this;
        return {
            culumnChartNumbersTitle: "Variation Quotidienne des Ventes Par Nombre de Commandes",
            columnChartAmountTitle: "Variation Quotidienne des Ventes Par Chiffre D'affaires",
            rangePicker: ['2019-05-01', '2019-05-10'],
            comparisonModeNumbers: 'none',
            comparisonModeAmount: 'none',
            comparisonOptions: [
                { value: 'none', text: 'Sans comparaison' },
                { value: 'year', text: 'Comparer avec l\'année précédente (N-1)' },
                { value: 'month', text: 'Comparer avec le mois précédent (M-1)' }
            ],
            currentOrders: [],
            comparisonOrders: { year: null, month: null },
            tooltipDatesNumbers: { current: [], comparison: [] },
            tooltipDatesAmount: { current: [], comparison: [] },
            columnChartNumbers: {
                series: [{
                    name: 'Nombre Total',
                    data: []
                }],
                chartOptions: {
                    colors: [$themeColors.primary, $themeColors.secondary],
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            endingShape: 'rounded',
                            columnWidth: '55%',
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        width: 5,
                        curve: 'smooth',
                        show: true,
                    },

                    xaxis: {
                        categories: [],
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return kFormatter(value);
                            }
                        },
                    },
                    tooltip: {
                        custom(ctx) {
                            return vm.renderComparisonTooltip(ctx, 'numbers');
                        }
                    }
                }
            },
            columnChartAmount: {
                series: [{
                    name: 'Montant Total',
                    data: []
                }],
                chartOptions: {
                    colors: [$themeColors.success, $themeColors.secondary],
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            endingShape: 'rounded',
                            columnWidth: '45%',
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },

                    xaxis: {
                        categories: [],
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return kFormatter(value);
                            }
                        },
                    },
                    fill: {
                        opacity: 1

                    },
                    tooltip: {
                        custom(ctx) {
                            return vm.renderComparisonTooltip(ctx, 'amount');
                        }
                    }
                }
            },
            pieChartNumbers: {
                series: [],
                chart: {
                    width: 380,
                    type: 'pie',
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }],
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return kFormatter(val);
                        }
                    }
                }
            },
            pieChartAmount: {
                series: [],
                chart: {
                    width: 380,
                    type: 'pie',
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }],
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return kFormatter(val);
                        }
                    }
                }
            },
            showDataKeys: 0,
            showLoading: true,
            startDate: new Date().toISOString().split('T')[0],
            endDate: new Date().toISOString().split('T')[0],
        }
    },
    computed: {
        rangeDays() {
            return Math.floor((new Date(this.endDate) - new Date(this.startDate)) / (1000 * 60 * 60 * 24));
        }
    },
    watch: {
        rangePicker(dateString) {
            if (dateString.includes("to")) {
                const dateArray = dateString.split(" to ");
                if (dateArray.length === 2) {
                    const startDate = dateArray[0];
                    const endDate = dateArray[1];
                    this.startDate = startDate;
                    this.endDate = endDate;
                    this.loadData();
                } else {
                    console.log("Invalid date format.");
                }
            } else {
                console.log("Substring 'to' not found in the string.");
            }
        },
        comparisonModeNumbers() {
            this.onComparisonModeChange();
        },
        comparisonModeAmount() {
            this.onComparisonModeChange();
        }
    },
    methods: {
        async loadData() {
            this.showLoading = true;
            // the cached comparison data belongs to the previous range
            this.comparisonOrders = { year: null, month: null };
            let response = await this.$http.post("order_header/findWhere", this.generateDateFilters(this.startDate, this.endDate)).catch(() => null);
            this.currentOrders = response ? response.data : [];
            let Top10ClientsByOrders = this.getTop10ClientsByOrders(this.currentOrders);
            this.pieChartNumbers.series = Top10ClientsByOrders.data;
            this.pieChartNumbers.labels = Top10ClientsByOrders.labels;
            let Top10ClientsByAmount = this.getTop10ClientsByAmount(this.currentOrders);
            this.pieChartAmount.series = Top10ClientsByAmount.data;
            this.pieChartAmount.labels = Top10ClientsByAmount.labels;
            await this.refreshComparisons();
            this.showLoading = false;
        },
        async onComparisonModeChange() {
            this.showLoading = true;
            await this.refreshComparisons();
            this.showLoading = false;
        },
        async refreshComparisons() {
            const modes = new Set([this.comparisonModeNumbers, this.comparisonModeAmount]);
            modes.delete('none');
            for (const mode of modes) {
                if (!this.comparisonOrders[mode]) {
                    const start = this.shiftDayKeyClamped(this.startDate, mode);
                    const end = this.shiftDayKeyClamped(this.endDate, mode);
                    const response = await this.$http.post("order_header/findWhere", this.generateDateFilters(start, end)).catch(() => null);
                    this.comparisonOrders[mode] = response ? response.data : [];
                }
            }
            this.rebuildCharts();
        },
        rebuildCharts() {
            const daily = this.rangeDays < 50;
            let keys, labels;
            if (daily) {
                this.culumnChartNumbersTitle = "Variation Quotidienne des Ventes Par Nombre de Commandes";
                this.columnChartAmountTitle = "Variation Quotidienne des Ventes Par Chiffre D'affaires";
                keys = this.listDaysBetween(this.startDate, this.endDate);
                labels = keys.map(k => new Date(k).toLocaleDateString('en-US', {
                    day: '2-digit',
                    month: 'short'
                }));
            } else {
                this.culumnChartNumbersTitle = "Variation Mensuelle des Ventes Par Nombre de Commandes";
                this.columnChartAmountTitle = "Variation Mensuelle des Ventes Par Chiffre D'affaires";
                keys = this.listMonthsBetween(this.startDate, this.endDate);
                labels = keys.map(k => this.formatMonthLabel(k));
            }
            const currentGrouped = daily ? this.groupOrdersByDay(this.currentOrders) : this.groupOrdersByMonth(this.currentOrders);
            this.buildComparableChart(this.columnChartNumbers, this.tooltipDatesNumbers, 'Nombre Total', 'count', currentGrouped, this.comparisonModeNumbers, daily, keys, labels);
            this.buildComparableChart(this.columnChartAmount, this.tooltipDatesAmount, 'Montant Total', 'amount', currentGrouped, this.comparisonModeAmount, daily, keys, labels);
            this.showDataKeys += 1;
        },
        buildComparableChart(chart, tooltipDates, baseName, field, currentGrouped, mode, daily, keys, labels) {
            chart.chartOptions.xaxis.categories = labels;
            tooltipDates.current = keys.map(k => daily ? this.formatDayFr(k) : this.formatMonthLabel(k));
            const series = [{
                name: baseName,
                data: keys.map(k => currentGrouped[k] ? currentGrouped[k][field] : 0)
            }];
            if (mode !== 'none') {
                const compGrouped = daily ? this.groupOrdersByDay(this.comparisonOrders[mode] || []) : this.groupOrdersByMonth(this.comparisonOrders[mode] || []);
                const shiftedKeys = keys.map(k => daily ? this.shiftDayKey(k, mode) : this.shiftMonthKey(k, mode));
                series.push({
                    name: mode === 'year' ? 'Année précédente (N-1)' : 'Mois précédent (M-1)',
                    data: shiftedKeys.map(sk => sk === null ? null : (compGrouped[sk] ? compGrouped[sk][field] : 0))
                });
                tooltipDates.comparison = shiftedKeys.map(sk => {
                    if (sk === null) return null;
                    return daily ? this.formatDayFr(sk) : this.formatMonthLabel(sk);
                });
            } else {
                tooltipDates.comparison = [];
            }
            chart.series = series;
        },
        renderComparisonTooltip({ series, dataPointIndex, w }, chartKey) {
            const dates = chartKey === 'numbers' ? this.tooltipDatesNumbers : this.tooltipDatesAmount;
            const isAmount = chartKey === 'amount';
            let html = '<div style="padding: 8px 12px;">';
            series.forEach((s, i) => {
                const dateLabel = i === 0 ? dates.current[dataPointIndex] : dates.comparison[dataPointIndex];
                const rawValue = s[dataPointIndex];
                let valueLabel;
                if (rawValue === null || rawValue === undefined || dateLabel === null) {
                    valueLabel = '—';
                } else {
                    valueLabel = isAmount ? parseFloat(rawValue).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') : rawValue;
                }
                const color = (w.globals.colors && w.globals.colors[i]) || '#888';
                const name = (w.globals.seriesNames && w.globals.seriesNames[i]) || '';
                html += '<div style="margin: 2px 0;">'
                    + '<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:' + color + ';margin-right:6px;"></span>'
                    + '<strong>' + name + '</strong>'
                    + (dateLabel ? ' (' + dateLabel + ')' : '')
                    + ' : ' + valueLabel
                    + '</div>';
            });
            return html + '</div>';
        },
        getTop10ClientsByOrders(inputList) {
            const clientOrders = {};

            // Step 1: Count the number of orders for each client
            inputList.forEach(item => {
                const customerName = item.Bill_to_Name;

                if (!clientOrders[customerName]) {
                    clientOrders[customerName] = 0;
                }
                clientOrders[customerName]++;
            });

            // Step 2: Sort clients by the number of orders in descending order
            const sortedClients = Object.keys(clientOrders).sort((a, b) => clientOrders[b] - clientOrders[a]);

            // Step 3: Get the top 10 clients
            const top10Clients = sortedClients.slice(0, 10);

            // Step 4: Prepare the output dataset
            const labels = top10Clients;
            const data = top10Clients.map(client => clientOrders[client]);

            return {
                labels,
                data,
            };
        },
        getTop10ClientsByAmount(inputList) {
            const clientAmounts = {};

            // Step 1: Calculate the total amount spent by each client
            inputList.forEach(item => {
                const customerName = item.Bill_to_Name;
                const amount = parseFloat(item.Amount_Including_VAT);

                if (!clientAmounts[customerName]) {
                    clientAmounts[customerName] = 0;
                }
                clientAmounts[customerName] += amount;
            });

            // Step 2: Sort clients by the total amount spent in descending order
            const sortedClients = Object.keys(clientAmounts).sort((a, b) => clientAmounts[b] - clientAmounts[a]);

            // Step 3: Get the top 10 clients
            const top10Clients = sortedClients.slice(0, 10);

            // Step 4: Prepare the output dataset
            const labels = top10Clients;
            const data = top10Clients.map(client => clientAmounts[client]);

            return {
                labels,
                data,
            };
        },
        groupOrdersByDay(inputList) {
            const grouped = {};
            inputList.forEach(item => {
                const key = ('' + item.Posting_Date).split('T')[0];
                if (!grouped[key]) {
                    grouped[key] = { count: 0, amount: 0 };
                }
                grouped[key].count++;
                grouped[key].amount += parseFloat(item.Amount_Including_VAT);
            });
            return grouped;
        },
        groupOrdersByMonth(inputList) {
            const grouped = {};
            inputList.forEach(item => {
                const key = ('' + item.Posting_Date).split('T')[0].slice(0, 7);
                if (!grouped[key]) {
                    grouped[key] = { count: 0, amount: 0 };
                }
                grouped[key].count++;
                grouped[key].amount += parseFloat(item.Amount_Including_VAT);
            });
            return grouped;
        },
        listDaysBetween(startString, endString) {
            const days = [];
            const current = new Date(startString);
            const end = new Date(endString);
            while (current <= end) {
                days.push(`${current.getFullYear()}-${(current.getMonth() + 1 + "").padStart(2, "0")}-${(current.getDate() + "").padStart(2, "0")}`);
                current.setDate(current.getDate() + 1);
            }
            return days;
        },
        listMonthsBetween(startString, endString) {
            const months = [];
            const start = new Date(startString);
            const end = new Date(endString);
            let year = start.getFullYear();
            let month = start.getMonth() + 1;
            const endYear = end.getFullYear();
            const endMonth = end.getMonth() + 1;
            while (year < endYear || (year === endYear && month <= endMonth)) {
                months.push(`${year}-${(month + "").padStart(2, "0")}`);
                month++;
                if (month > 12) {
                    month = 1;
                    year++;
                }
            }
            return months;
        },
        // '2026-08-02' shifted one year or one month back; null when the target day
        // does not exist (e.g. 31/07 -> 31/06, 29/02 outside leap years)
        shiftDayKey(dayKey, mode) {
            const [year, month, day] = dayKey.split('-').map(Number);
            let targetYear, targetMonth;
            if (mode === 'year') {
                targetYear = year - 1;
                targetMonth = month;
            } else {
                targetYear = month === 1 ? year - 1 : year;
                targetMonth = month === 1 ? 12 : month - 1;
            }
            const lastDay = new Date(targetYear, targetMonth, 0).getDate();
            if (day > lastDay) return null;
            return `${targetYear}-${(targetMonth + "").padStart(2, "0")}-${(day + "").padStart(2, "0")}`;
        },
        // same shift but clamped to the last existing day, for the fetch window bounds
        shiftDayKeyClamped(dayKey, mode) {
            const [year, month, day] = dayKey.split('-').map(Number);
            let targetYear, targetMonth;
            if (mode === 'year') {
                targetYear = year - 1;
                targetMonth = month;
            } else {
                targetYear = month === 1 ? year - 1 : year;
                targetMonth = month === 1 ? 12 : month - 1;
            }
            const lastDay = new Date(targetYear, targetMonth, 0).getDate();
            const targetDay = Math.min(day, lastDay);
            return `${targetYear}-${(targetMonth + "").padStart(2, "0")}-${(targetDay + "").padStart(2, "0")}`;
        },
        // '2026-08' -> '2025-08' (year) or '2026-07' (month)
        shiftMonthKey(monthKey, mode) {
            const [year, month] = monthKey.split('-').map(Number);
            if (mode === 'year') {
                return `${year - 1}-${(month + "").padStart(2, "0")}`;
            }
            const targetYear = month === 1 ? year - 1 : year;
            const targetMonth = month === 1 ? 12 : month - 1;
            return `${targetYear}-${(targetMonth + "").padStart(2, "0")}`;
        },
        formatDayFr(dayKey) {
            const [year, month, day] = dayKey.split('-');
            return `${day}/${month}/${year}`;
        },
        formatMonthLabel(monthKey) {
            const [year, month] = monthKey.split('-').map(Number);
            return new Date(year, month - 1, 1).toLocaleString('default', { year: 'numeric', month: 'long' });
        },
        getFirstAndLastDay(year, month) {
            // Ensure month is in the range 1-12
            if (month < 1 || month > 12) {
                throw new Error("Month must be between 1 and 12.");
            }

            // Create a new date object for the first day of the month
            const firstDay = new Date(year, month - 1, 1);

            // Create a new date object for the last day of the next month, then subtract one day
            const lastDay = new Date(year, month, 0);

            // Format dates as "YYYY-MM-DD"
            const formattedFirstDay = `${firstDay.getFullYear()}-${(month + "").padStart(2, "0")}-01`;
            const formattedLastDay = `${lastDay.getFullYear()}-${(month + "").padStart(2, "0")}-${lastDay.getDate()}`;

            return {
                firstDay: formattedFirstDay,
                lastDay: formattedLastDay
            };
        },
        getCurrentAndPastDay(days) {
            const currentDate = new Date();
            const pastDate = new Date();
            pastDate.setDate(pastDate.getDate() - days);

            const formattedCurrentDay = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1 + "").padStart(2, "0")}-${currentDate.getDate()}`;
            const formattedPastDay = `${pastDate.getFullYear()}-${(pastDate.getMonth() + 1 + "").padStart(2, "0")}-${pastDate.getDate()}`;

            return {
                currentDay: formattedCurrentDay,
                pastDay: formattedPastDay,
            };
        },
        generateDateFilters(startDate, endDate) {
            const filters = [
                {
                    "field": "Posting_Date",
                    "value": "",
                    "operator": "gt"
                },
                {
                    "field": "Posting_Date",
                    "value": "",
                    "operator": "lt"
                }
            ];

            // Convert start date string to Date and adjust by -1 day
            const startDateObj = new Date(startDate);
            startDateObj.setDate(startDateObj.getDate() - 1);

            // Convert end date string to Date and adjust by +1 day
            const endDateObj = new Date(endDate);
            endDateObj.setDate(endDateObj.getDate() + 1);

            // Format adjusted dates as strings in yyyy-MM-dd format
            const formattedStartDate = startDateObj.toISOString().split('T')[0];
            const formattedEndDate = endDateObj.toISOString().split('T')[0];

            // Set adjusted date values in the filter objects
            filters[0].value = formattedStartDate;
            filters[1].value = formattedEndDate;

            return filters;
        },
    },
    created() {
        let data = this.getCurrentAndPastDay(20);
        this.rangePicker[0] = data.pastDay;
        this.rangePicker[1] = data.currentDay;
        this.startDate = data.pastDay;
        this.endDate = data.currentDay;
        this.loadData();
    },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
